'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

exports.default = _react.PropTypes.shape({
  buttonBackgroundColor: _react.PropTypes.string,
  breakpointSettings: _react.PropTypes.objectOf(_react.PropTypes.shape({
    gutterSize: _react.PropTypes.string.isRequired,
    itemsPerPage: _react.PropTypes.number.isRequired,
    partiallyShowOffscreenItems: _react.PropTypes.bool.isRequired,
    showDots: _react.PropTypes.bool.isRequired,
    useTouchArrows: _react.PropTypes.bool.isRequired
  })).isRequired
}).isRequired;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/bc-prop-types/lib/components/CarouselSettingShape.js
// module id = 290
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14